export const passwordMessages = {
    required: () => 'Required',
    minLength: ({ $params }) => `Must be at least ${$params.minLength.min} characters.`,
    maxLength: ({ $params }) => `Must be less than ${$params.maxLength.max} characters.`,
    spacesNotAllowed: () => 'Spaces not allowed',
    lowerCasePatternTest: () => 'Must be at least one LOWERCASE character:',
    upperCasePatternTest: () => 'Must be at least one UPPERCASE character',
    numberPatternTest: () => 'Must be at least one NUMBER'
};
